module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/Sale#2-7a7604cce6d0e254589a05fed55a0f26.svg";